import { useScrollLock } from "../../hooks/useScrollLock";

interface GenericLoaderProps {
  lock?: boolean;
  message?: string;
  variant?: "fullscreen" | "overlay" | "inline";
}

const GenericLoader = ({
  message = "Loading...",
  variant = "fullscreen",
  lock = false,
}: GenericLoaderProps) => {
  useScrollLock(lock && variant !== "inline");

  const isOverlay = variant === "overlay";

  const containerStyles = {
    fullscreen: "h-screen w-full bg-white",
    overlay: "fixed inset-0",
    inline: "h-full w-full py-6",
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex flex-col justify-center items-center gap-4 ${containerStyles[variant]}`}
    >
      {/* BACKDROP */}
      {isOverlay && (
        <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />
      )}

      {/* CONTENT */}
      <div className="relative z-10 flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-[2.5px] border-gray-300" />
          <div className="absolute inset-0 rounded-full border-[2.5px] border-transparent border-t-[#f59e0b] animate-spin" />
        </div>

        {message && (
          <p
            className={`text-sm ${variant === "overlay" ? "text-white/80" : "text-gray-600"
              }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default GenericLoader;
